import { k } from "../../i18n/i18n";

/** Les huit climats (environment.CLIMATE_ZONES), libellés du serveur (environment.CLIMATE_LABELS, copie vérifiée dans
 *  `map/zones/serverMessages.json`), dans son ordre : les quatre de l'iPad, puis les quatre rédigés pour le web. Un seul
 *  nom par climat dans toute l'interface (« Montagnard », jamais « de montagne »). */
export const CLIMATES: readonly { key: string; label: string }[] = [
  { key: "oceanic", label: k("Océanique") },
  { key: "semiContinental", label: k("Semi-continental") },
  { key: "mediterranean", label: k("Méditerranéen") },
  { key: "highland", label: k("Montagnard") },
  { key: "tropical", label: k("Tropical") },
  { key: "subtropicalMonsoon", label: k("Subtropical de mousson") },
  { key: "arid", label: k("Aride") },
  { key: "subarctic", label: k("Subarctique") },
];
